import { urlApi } from './api'
import { base, lireReglage } from './db'
import { emettre } from './bus'
import type { Espece, TotauxSaison, TypeSignalement } from '../domaine/types'

/*
  Chiffres de la saison.

  L'écran lit TOUJOURS le cache local : il fonctionne hors réseau, avec la date
  de la dernière synchronisation affichée. Le rafraîchissement est opportuniste
  et ne bloque jamais l'affichage.
*/

const CLE = 'courante'

export type TotauxCache = TotauxSaison & { recu_le: string }

export async function totauxEnCache(): Promise<TotauxCache | undefined> {
  const db = await base()
  return db.get('cache_saison', CLE)
}

export async function rafraichirTotaux(): Promise<boolean> {
  const jeton = await lireReglage('device_token')
  if (!jeton || navigator.onLine === false) return false

  try {
    const r = await fetch(urlApi('saison/totaux'), {
      cache: 'no-store',
      headers: { 'X-Device-Token': jeton },
    })
    if (!r.ok) return false

    const totaux = (await r.json()) as TotauxSaison
    const db = await base()
    await db.put('cache_saison', { ...totaux, recu_le: new Date().toISOString() }, CLE)
    emettre('saison-changee')
    return true
  } catch {
    return false
  }
}

export interface TotauxLocaux {
  pontes: Record<Espece, number>
  traces_sans_ponte: number
  emergences: number
  personnes_sensibilisees: number
  signalements: Record<TypeSignalement, number>
}

/**
 * Chiffres saisis sur CET appareil.
 *
 * Affichés à côté des totaux serveur : une patrouille qui vient de compter
 * trente personnes doit voir ses trente personnes, même si rien n'est encore
 * parti.
 */
export async function totauxLocaux(): Promise<TotauxLocaux> {
  const db = await base()
  const observations = await db.getAll('observations')
  const signalements = await db.getAll('signalements')

  const resultat: TotauxLocaux = {
    pontes: { luth: 0, olivatre: 0, verte: 0 },
    traces_sans_ponte: 0,
    emergences: 0,
    personnes_sensibilisees: 0,
    signalements: {
      eclairage: 0,
      chien_divagation: 0,
      emergence_desorientee: 0,
      tortue_blessee: 0,
    },
  }

  for (const o of observations) {
    if (o.type === 'ponte' && o.espece) resultat.pontes[o.espece] += o.quantite
    else if (o.type === 'trace_sans_ponte') resultat.traces_sans_ponte += o.quantite
    else if (o.type === 'emergence') resultat.emergences += o.quantite
    else if (o.type === 'personne_sensibilisee') resultat.personnes_sensibilisees += o.quantite
  }

  for (const s of signalements) {
    resultat.signalements[s.type] += 1
  }

  return resultat
}
